import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

/**
 * Components/Grid/Row
 * ----------------------------------------------------------------------
 * Row para uso com o grid do framework, compatível com Bootstrap 4.
 * 
 * @param {*} props 
 *     Objeto com propriedades do componente, como id, classe, children e se 
 *     possui gutters
 */
export const Row = ({id, className, children, noGutters}) => {
  let _cls = ["row"];
  if (noGutters) _cls.push("no-gutter");

  return (
    <div id={id} className={classnames(_cls, className)}>
      {children}
    </div>
  );
};

Row.defaultProps = {
  id: "",
  className: "",
  children: null,
  noGutters: false
};

Row.propTypes = {
  id: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  children: PropTypes.node,
  noGutters: PropTypes.bool
};
